// Канонический источник ключа агрегации уведомлений «артефакт готов».
//
// Используется одновременно:
//   - диспетчером уведомлений (Inngest `artifact/notify.requested`) при создании
//     in-app записи и Redis seen-флага;
//   - страницами-«свидетелями» на фронте (хук `useMarkArtifactSeen`) для
//     `markSeen({ groupKey, level })`.
// Один источник истины гарантирует, что серверный groupKey и клиентский совпадают
// побайтно — иначе seen-флаг не сматчится и подавление email/push не сработает.

/** Тип артефакта — единый union для уведомлений (presence-aware подавление). */
export type ArtifactKind =
	| "material"
	| "notes"
	| "flashcards"
	| "quiz"
	| "recording"
	| "audio-recap"
	| "essay"
	| "visual"
	| "glossary"
	| "study-plan";

/** Стабильный ключ агрегации `<kind>:<entityId>`. */
export function artifactGroupKey(kind: ArtifactKind, entityId: string): string {
	return `${kind}:${entityId}`;
}
